type Props<T extends string | number> = {
    value: T;
    default?: T;
    cases: { [key in T]: React.ReactNode };
};
export function Switch<T extends string | number>({
    value,
    default: _default,
    cases,
}: Props<T>) {
    return cases[value] ?? cases[_default] ?? null;
}
